"use client";

import { type PropsWithChildren } from "react";

import { cn } from "../../utils";
import { useBadgeRootContext } from "./context";
import { labelStyles } from "./style";

export type BadgeLabelProps = PropsWithChildren & {
  className?: string;
  style?: React.CSSProperties;
};

export const Label = (props: BadgeLabelProps) => {
  const { size, variant } = useBadgeRootContext();

  return (
    <div style={props.style} className={cn(labelStyles({ size, variant }), props.className)}>
      {props.children}
    </div>
  );
};
